import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Detalheplanomodal from './detalheplanomodal'
import { fetchDetalhePlano, clearDetalhePlano } from './redux/detalheplanoActions'
import './detalheplano.scss'

const Detalheplano = ({ open, close, planoId }) => {
  const dispatch = useDispatch()

  const { sistema } = useSelector(state => state.layoutState)
  const nls = require(`./nls/${sistema.idioma}.json`)

  const { loading, data, error } = useSelector(
    state => state.pdcaState.pdcaPlanDetailsState
  )

  useEffect(() => {
    if (open && planoId) {
      dispatch(fetchDetalhePlano(planoId))
    }
  }, [dispatch, open, planoId])

  useEffect(() => {
    if (!open) {
      dispatch(clearDetalhePlano())
    }
  }, [dispatch, open])

  useEffect(() => {
    if (open && error) {
      dispatch(clearDetalhePlano())
      close()
    }
  }, [dispatch, open, error, close])

  const handleClose = () => {
    dispatch(clearDetalhePlano())
    close()
  }

  return (
    <Detalheplanomodal
      open={open}
      close={handleClose}
      planoId={planoId}
      loading={loading}
      data={data}
      error={error}
      nls={nls}
    />
  )
}

export default Detalheplano